import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "hooks/hooks";
import { getInitialSearchDto } from "models/SearchTransactionDto";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { setSearchDto } from "reducers/dto.slice";
import { clearOrder } from "reducers/order.slice";
import { getCustomerById } from "services/customer.service";

const OemAdmin = () => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const oemCustomers = useAppSelector(state => state.customers.oemDropDown);

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const handleChange = (customerId: string) => {
        dispatch(clearOrder());
        dispatch(setSearchDto(getInitialSearchDto(customerId)));
        dispatch(getCustomerById(customerId));
        navigate('/alliance/dashboard');
    }

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
    
    return (
        <Dropdown nav isOpen={dropdownOpen} toggle={toggleDropdown}>
            <DropdownToggle nav caret>
                Customers
            </DropdownToggle>
            <DropdownMenu className="bcd-dropdown-scroll">
                {oemCustomers.map((c, index) => {
                    return (
                        <div key={c.id}>
                            <DropdownItem key={c.id} onClick={() => handleChange(c.id)}>{c.display}</DropdownItem>
                            {index < oemCustomers.length - 1 && <DropdownItem divider />}
                        </div>
                    );
                })
                }
            </DropdownMenu>
        </Dropdown>);
}

export default OemAdmin;